// extracted by mini-css-extract-plugin
export default {"section":"recipe_section__Kqf-K","article":"recipe_article__u97-r","content":"recipe_content__DQqkW","imgbox":"recipe_imgbox__DI7uV"};